module.exports = __webpack_public_path__ + "static/img/role.03e69f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role.png
// module id = YDuB
// module chunks = 7